import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const WellnessProductCard = ({ product }) => {
  const image = product.thumbnail || product.image || (product.images && product.images[0]);
  const description = product.shortDescription || product.description;

  return (
    <Link
      to={`/espace-client/${product.id}`}
      className="group bg-white rounded-lg overflow-hidden shadow-md hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 h-full flex flex-col block"
    >
      {/* Image */}
      <div className="relative h-64 overflow-hidden bg-gray-200">
        <img
          src={image}
          alt={product.name}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
          loading="lazy"
          onError={(e) => {
            e.target.src = 'https://via.placeholder.com/800x600?text=Image+non+disponible';
            e.target.onerror = null;
            e.target.className = 'w-full h-full object-cover bg-gray-200';
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
      </div>

      {/* Content */}
      <div className="p-6 flex flex-col flex-grow">
        <h3 className="text-xl font-bold text-gray-800 mb-2 group-hover:text-[#c4d600] transition-colors">
          {product.name}
        </h3>
        <p className="text-sm text-gray-600 mb-4 flex-grow">
          {description}
        </p>
        
        {/* Link */}
        <div className="inline-flex items-center text-[#c4d600] hover:text-[#b0c200] font-semibold text-sm transition-all duration-300 group/link">
          En savoir plus
          <ArrowRight className="w-4 h-4 ml-2 group-hover/link:translate-x-1 transition-transform duration-300" />
        </div>
      </div>
    </Link>
  );
};

export default WellnessProductCard;
